export const GAIA_BU_NAMES = [
    'Visma Software AS',
    'Visma Software A/S',
    'Visma Software AB'
]

export const BU_Visma_Enterprise_AS = 'Visma Enterprise AS';